module.exports = __webpack_public_path__ + "static/media/tomorrowHeadliners.bfeaa8ac.png";